import { RE } from './regexp';
import { isObject } from '~/modules/helpers/object';

const { String } = window;

const RE_ConsequentSpaces = /\s+/;

export const tokenize = str => str.split(RE_ConsequentSpaces);

export const capitalizeEachWord = str => {
    const words = tokenize(str);
    const len = words.length;
    for (let i = 0; i < len; ++i) {
        words[i] = capitalizeFirstLetter(words[i]);
    }
    return words.join('\u0020');
};

export const capitalizeFirstLetter = str => {
    const cp = str?.codePointAt(0);
    return cp
        ? String.fromCodePoint(cp).toUpperCase() +
              str.slice(cp > 0xffff ? 2 : 1)
        : '';
};

export const lowerCaseFirstLetter = str => {
    const cp = str?.codePointAt(0);
    return cp
        ? String.fromCodePoint(cp).toLowerCase() +
              str.slice(cp > 0xffff ? 2 : 1)
        : '';
};

export function includesInsensitive(str, search) {
    return typeof str !== 'undefined'
        ? String(str)
              .toLowerCase()
              .includes(search.toLowerCase())
        : false;
}

export const removeTrailingSlash = str => {
    return str?.endsWith ? (str.endsWith('/') ? str.slice(0, -1) : str) : '';
};

export const addTrailingSlash = str => {
    return str?.endsWith ? (str.endsWith('/') ? str : `${str}/`) : '';
};

/** RN:
 * Return html classes in string format starting evaluating different input formats
 * @function
 * @param {string} customClasses - If string return the value overriding all defaults
 * @param {Array} customClasses - If array return given classes merged with defaults
 * @param {function} customClasses - If function return the result of function that will receive the defaults
 * @param {Array} defaultClasses - The default list of classes
 * @returns {string} The resulting string
 */
export function htmlClassesToString(customClasses, defaultClasses = []) {
    if (!customClasses) {
        return defaultClasses.join(' ');
    }
    if (Array.isArray(customClasses)) {
        return [...defaultClasses, ...customClasses].join(' ');
    }
    if (typeof customClasses === 'function') {
        return customClasses(defaultClasses);
    }
    return customClasses;
}

export const toRGBobj = (str, fallback) => {
    let RGB;
    let defaultObj = {
        r: 0,
        g: 0,
        b: 0
    };
    if (str) {
        let obj;
        if (isObject(str)) {
            if (
                'r' in str ||
                'g' in str ||
                'b' in str // merge:
            ) {
                obj = {
                    ...defaultObj,
                    ...str
                };
            }
        } else {
            const match = str && str.match?.(RE.COLOR.rgbaValidValues);
            if (match) {
                obj = {
                    ...defaultObj,
                    r: parseInt(match[1]),
                    g: parseInt(match[2]),
                    b: parseInt(match[3])
                };
            }
        }
        if (obj && Object.values(obj).every(e => 256 > e && 0 <= e)) {
            RGB = obj;
        }
    }
    return RGB || (fallback ?? defaultObj);
};
